import React from 'react';
import { useTranslation } from 'react-i18next';
import './employer-certificate-header.component.scss';
import { INVOZIO_BLOB_BASE } from '../../constant/video-url-import.constant';
const videoCameraIcon = (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 10L20 7V17L15 14V10Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="3" y="7" width="12" height="10" rx="2" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const playArrowIcon = (
    <svg width="8" height="10" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 1L8.5 5.5L0.5 10V1Z" fill="#6750b8" stroke="#6750b8" strokeWidth="0.5" strokeLinejoin="round"/>
    </svg>
);

const videoUrlEn = `${INVOZIO_BLOB_BASE}/employer_certificate_en.mp4`
const videoUrlSv = `${INVOZIO_BLOB_BASE}/employer_certificate_sv.mp4`

export const EmployerCertificateHeader: React.FC = () => {
    const { t } = useTranslation();
    const lang = new URLSearchParams(window.location.search).get('lang') || 'en-us';
    const isSv = lang === 'en-us' ? false : true
    const handleButtonClick=() =>{
      window.open(isSv ? videoUrlSv : videoUrlEn, '_blank', 'noopener,noreferrer');
    }

    return (
        <div className="employer-certificate-header">
            <div className="employer-certificate-header__card">
                {/* <div className='employer-certificate-header__title-btn'> */}
                <h1 className="employer-certificate-header__title">
                    {t('Employer Certificate')}
                </h1>
                {/* </div> */}
                <p className="employer-certificate-header__description">
                    {t('employerCertificateDescription')}
                </p>
                <div
                    className='employer-certificate-header__banner'
                    onClick={handleButtonClick}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === 'Enter' && handleButtonClick()}
                >
                    <div className='employer-certificate-header__banner-left'>
                        <div className='employer-certificate-header__banner-icon'>
                            {videoCameraIcon}
                        </div>
                        <span className='employer-certificate-header__banner-text'>{t('employerCertificateTutorial')}</span>
                    </div>
                    <div className='employer-certificate-header__banner-action'>
                        <span>{t('employerCertificateWatch')}</span>
                        {playArrowIcon}
                    </div>
                </div>
            </div>
        </div>
    );
};
